import {useState, useRef, useEffect} from 'react';

export const useScreenState = (props) => {
    const {timeout, defaultState, maxState} = {
        timeout: 300,
        defaultState: -1,
        maxState: 2,
        ...(props ?? {}),
    };

    //-1 not mounted,
    // 0 loading without pagination change,
    // 1 loading with pagination change,
    // 2 ready
    const [state, setState] = useState(defaultState);
    const [realState, setRealState] = useState(state);
    const stateTimeout = useRef(null);
    useEffect(() => {
        clearTimeout(stateTimeout.current);
        const localTimeout = state === maxState ? timeout : 0;
        if (localTimeout === 0) {
            setRealState(() => state);
            stateTimeout.current = null;
        } else {
            stateTimeout.current = setTimeout(() => {
                setRealState(() => state);
                stateTimeout.current = null;
            }, localTimeout);
        }
        return () => {
            clearTimeout(stateTimeout.current);
        };
    }, [state, timeout, maxState]);

    //-1 not mounted, 0 loading, 1 ready
    const [isMounted, setIsMounted] = useState(false);
    const isMountedTimeout = useRef(null);
    useEffect(() => {
        clearTimeout(isMountedTimeout.current);
        isMountedTimeout.current = setTimeout(() => {
            setIsMounted(() => state !== -1);
            isMountedTimeout.current = null;
        }, timeout);
        return () => {
            clearTimeout(isMountedTimeout.current);
        };
    }, [state, timeout]);

    return {
        isMounted,
        realState,
        state,
        setState,
    };
};

export default useScreenState;
